<template>

    <v-container fluid class="container-pizzas d-flex flex-column ">
        <v-row class="row">

            <v-col :cols='isMobile ? 12 : 6' class='d-flex flex-column justify-center align-center '>

                <sheets-data 

                    :loading="loading"
                    :faceClicks="faceClicks" 
                    :websiteClicks="websiteClicks" 
                    :phoneClicks="phoneClicks" 
                    :whatsClicks="whatsClicks" 
                    :buynowClicks="buynowClicks" 
                    :showedData="showedData" 
                    :impressions="impressions" 
                    
                />

            </v-col>

            <v-col :cols='isMobile ? 12 : 6'  class='d-flex flex-column justify-center align-center'>

                <div class="text-uppercase font-weight-bold text-chart deep-orange--text">{{$t('dash_overview.pie_chart')}}</div>

                <pie-chart class="pie-chart" :data="pieData" :colors="colors"></pie-chart>

            </v-col>

        </v-row>
    </v-container>

</template>

<script>

import SheetsData from './SheetsData.vue'

export default {

    components: { SheetsData },

    name: 'ClicksContainer',

    props: [
        'loading', 
        'showedData', 
        'faceClicks', 
        'whatsClicks', 
        'phoneClicks', 
        'websiteClicks',
        'buynowClicks',
        'impressions', 
        'pieData'
    ],

    data() {
        
        return {

            colors: [
                '#9e9e9e',
                '#e91e63',
                '#2196f3',
                '#4caf50',
                '#ff9800'
            ]

        }


    }

}

</script>

<style scoped>

.container-pizzas {

    background-color: white;
    height: 400px;


}

.row {

    margin-top: 30px

}

.text-chart {

    font-size: 23px;

}

</style>